var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bld-cat-pick-main"},[_c('div',{staticClass:"title wi8_font"},[_vm._v("Category Picker Builder (cat: "+_vm._s(_vm.current.cat.title)+")")]),_c('CatPick')],1)}
var staticRenderFns = []

export { render, staticRenderFns }